var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserLightCardGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.609 22.211c.062.466.203.683.303.787.133.137.457.346 1.255.355.185-1.244 1-2.502 2.177-3.463l.018-.014c-1.729.375-3.025 1.31-3.753 2.335zM8.984 15.427c0-1.753 1.363-3.098 2.954-3.146-.159.467-.246.973-.246 1.506 0 1.784.96 3.29 2.33 4.05a3.06 3.06 0 0 1-.87.563 8.938 8.938 0 0 0-.422.143 2.842 2.842 0 0 1-.704.089c-1.635 0-3.042-1.399-3.042-3.205z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9 23.352c.743-.02 1.054-.22 1.185-.356.107-.11.256-.341.314-.849-.734-.996-2.006-1.898-3.69-2.267l.013.01c1.178.96 1.993 2.219 2.178 3.462zM20.028 18.632c-.229 0-.453-.028-.67-.08a9.001 9.001 0 0 0-.482-.163 3.063 3.063 0 0 1-.834-.543c1.379-.757 2.353-2.273 2.353-4.076 0-.528-.084-1.027-.239-1.488 1.574.07 2.914 1.407 2.914 3.144 0 1.807-1.407 3.206-3.042 3.206z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.1 23.354H8.967c.398-2.063 3.034-4.558 7.064-4.558 4.035 0 6.671 2.494 7.069 4.558z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.043 17.542c1.905 0 3.565-1.638 3.565-3.772 0-2.108-1.66-3.67-3.565-3.67-1.907 0-3.564 1.596-3.564 3.687 0 2.117 1.648 3.755 3.564 3.755z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M23.778 25H8.222C6.067 25 5 23.887 5 21.683V10.307C5 8.102 6.067 7 8.222 7h15.556C25.923 7 27 8.113 27 10.307v11.376C27 23.887 25.923 25 23.778 25zM8.222 23.354c-.838 0-1.174-.216-1.31-.356-.132-.137-.335-.471-.335-1.315V10.307c0-.844.203-1.174.332-1.307.135-.138.47-.354 1.313-.354h15.556c.831 0 1.17.215 1.309.358.134.138.336.47.336 1.303v11.376c0 .84-.203 1.175-.338 1.313-.138.143-.475.358-1.307.358H8.222z",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLightCardGroup);
export default __webpack_public_path__ + "static/media/User-Light_Card-Group.e1710e75d1c790fa24ce290939f50e06.svg";
export { ForwardRef as ReactComponent };